import AllTestsIcon from '@/assets/icons/svg/all-tests.svg';
import TestTemplates from '@/assets/icons/svg/test-templates.svg';
import Mailings from '@/assets/icons/svg/mailing.svg';
import Reports from '@/assets/icons/svg/reports.svg';
import Company from '@/assets/icons/svg/company.svg';
import MyTests from '@/assets/icons/svg/my-tests.svg';
import Schedule from '@/assets/icons/svg/schedule.svg';
import Lectures from '@/assets/icons/svg/lectures.svg';
import Back from '@/assets/icons/svg/back.svg';
import Logout from '@/assets/icons/svg/logout.svg';
import MenuShort from '@/assets/icons/svg/menu-short.svg';
import Analytics from '@/assets/icons/svg/analytics.svg'
import Favourite from '@/assets/icons/svg/favourite.svg'
import ChevronArrow from '@/assets/icons/svg/chevron-arrow.svg'
import Sort from '@/assets/icons/svg/sort.svg'
import Clock from '@/assets/icons/svg/clock.svg'
import Plus from '@/assets/icons/svg/plus.svg'
import KebabMenu from '@/assets/icons/svg/kebab-menu.svg'
import Cross from '@/assets/icons/svg/cross.svg'
import Search from '@/assets/icons/svg/search.svg'
import Select from '@/assets/icons/svg/select.svg'
import Chart from '@/assets/icons/svg/chart.svg'
import Yandex from '@/assets/icons/svg/yandex.svg'
import Google from '@/assets/icons/svg/google.svg'
import VK from '@/assets/icons/svg/vk.svg'
import eye from '@/assets/icons/svg/eye.svg'
import eyeClosed from '@/assets/icons/svg/eye-closed.svg'
import reset from '@/assets/icons/svg/reset.svg'
import play from '@/assets/icons/svg/play.svg'
import pause from '@/assets/icons/svg/pause.svg'
import checked from  '@/assets/icons/svg/checked.svg'
import anonUser from '@/assets/icons/svg/anon-user.svg'
import settings from '@/assets/icons/svg/settings.svg'
import xlsx from '@/assets/icons/svg/xlsx.svg'
import listCheck from '@/assets/icons/svg/list-check.svg'
import tour from '@/assets/icons/svg/tour.svg'
import sixDots from '@/assets/icons/svg/six-dots.svg'
import mail from '@/assets/icons/svg/mail.svg'
import building from '@/assets/icons/svg/building.svg'
import editOutline from '@/assets/icons/svg/edit-outline.svg'
import star from '@/assets/icons/svg/star.svg'
import addToGroup from '@/assets/icons/svg/add-to-group.svg'
import upload from '@/assets/icons/svg/upload.svg'
import pdf from '@/assets/icons/svg/pdf.svg'
import highFive from '@/assets/icons/svg/high-five.svg'
import imageEmpty from '@/assets/icons/svg/image-empty.svg'
import imageEmptyPurple from '@/assets/icons/svg/image-empty-purple.svg'
import article from '@/assets/icons/svg/article.svg'
import openFolder from '@/assets/icons/svg/open-folder.svg'
import closedFolder from '@/assets/icons/svg/closed-folder.svg'
import creatingTemplate from '@/assets/icons/svg/creating-template.svg'
import creatingMailing from '@/assets/icons/svg/creating-mailing.svg'
import download from '@/assets/icons/svg/download.svg'
import json from '@/assets/icons/svg/json.svg'
import questionOutlined from '@/assets/icons/svg/question-outlined.svg'
import link from '@/assets/icons/svg/link.svg'
import approve from '@/assets/icons/svg/approve.svg'

export const ICONS = {
    'all-tests': AllTestsIcon,
    'test-templates': TestTemplates,
    'mailings': Mailings,
    'reports': Reports,
    'company': Company,
    'my-tests': MyTests,
    'schedule': Schedule,
    'lectures': Lectures,
    'back': Back,
    "logout": Logout,
    "menu-short": MenuShort,
    "analytics": Analytics,
    "favourite": Favourite,
    "chevron-arrow": ChevronArrow,
    "sort": Sort,
    "clock": Clock,
    "plus": Plus,
    'kebab-menu': KebabMenu,
    'cross': Cross,
    'search': Search,
    'select': Select,
    'chart': Chart,
    'yandex': Yandex,
    'google': Google,
    'vk': VK,
    'eye': eye,
    'eye-closed': eyeClosed,
    'reset': reset,
    'play': play,
    'pause': pause,
    'checked': checked,
    'anon-user': anonUser,
    'settings': settings,
    'xlsx': xlsx,
    'list-check': listCheck,
    'tour': tour,
    'six-dots': sixDots,
    'mail': mail,
    'building': building,
    'edit-outline': editOutline,
    'star': star,
    'add-to-group': addToGroup,
    'upload': upload,
    'pdf': pdf,
    'high-five': highFive,
    'image-empty': imageEmpty,
    'image-empty-purple': imageEmptyPurple,
    'article': article,
    'open-folder': openFolder,
    'closed-folder': closedFolder,
    'creating-template': creatingTemplate,
    'download': download,
    'json': json,
    'question-outlined': questionOutlined,
    'link': link,
    'creating-mailing': creatingMailing,
    'approve': approve
};